<template>
  <div class="section-backdrop" aria-hidden="true">
    <img v-if="bg" :src="bg" alt="" class="section-backdrop__art" />
    <ParticleField v-if="particles" :variant="variant" :count="count" />
  </div>
</template>

<script>
import ParticleField from '@/components/ParticleField.vue'

export default {
  name: 'SectionBackdrop',
  components: { ParticleField },
  props: {
    bg: { type: String, default: '' },
    variant: { type: String, default: 'light' },
    count: { type: Number, default: 24 },
    particles: { type: Boolean, default: true }
  }
}
</script>

<style scoped>
.section-backdrop {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}

.section-backdrop__art {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
